var Schedule;
((Schedule2) => {
  Schedule2.SYMBOL = Symbol.for("core:schedule-token");
})(Schedule || (Schedule = {}));
class ScheduleBase {
  constructor() {
    this._state = "INITIALIZE";
    this._totalCount = 0;
    this._successCount = 0;
    this._errorCount = 0;
  }
  get history() {
    return this._history;
  }
  get state() {
    return this._state;
  }
  get totalCount() {
    return this._totalCount;
  }
  get successCount() {
    return this._successCount;
  }
  get errorCount() {
    return this._errorCount;
  }
  get isReady() {
    return !(this._state === "RUNNING");
  }
  addStart(input, date = /* @__PURE__ */ new Date()) {
    this._history ?? (this._history = []);
    this._history.push({ state: "RUNNING", date, input });
  }
  addError(input, date = /* @__PURE__ */ new Date()) {
    this._history ?? (this._history = []);
    this._history.push({ state: "ERROR", date, input });
  }
  addSuccess(input, result = void 0, date = /* @__PURE__ */ new Date()) {
    this._history ?? (this._history = []);
    this._history.push({ state: "SUCCESS", date, input, result });
  }
  async run(data) {
    this._state = "RUNNING";
    this.addStart();
    const startDate = /* @__PURE__ */ new Date();
    let result;
    try {
      console.log("Running schedule", this.name, startDate);
      result = await this.execute(data);
      this._successCount++;
      this.addSuccess(data, result);
    } catch (e) {
      this.addError(e);
      this._errorCount++;
      const endDate = /* @__PURE__ */ new Date();
      console.error("Error schedule", this.name, endDate, endDate.getTime() - startDate.getTime(), e);
    } finally {
      this._totalCount++;
      const endDate = /* @__PURE__ */ new Date();
      console.log("Done schedule", this.name, endDate, endDate.getTime() - startDate.getTime());
    }
    this._state = "DONE-AND-WAITING";
    return result;
  }
}
export {
  Schedule,
  ScheduleBase
};
//# sourceMappingURL=Schedule.js.map
